import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

type IProps = React.DetailsHTMLAttributes<HTMLDetailsElement>;

export const AccordionItemBase = ({ className, open, ...props }: IProps) => {
  return (
    <details
      className={baseStyle.cls({ className })}
      open={open || undefined}
      {...props}
    />
  );
};

const baseStyle = tsv({
  base: "fs-accordion",
});
